/* mg-cart.js - MenoGlow: automatische Aktualisierung von Menge, Zeilenpreis und Zwischensumme im Warenkorb.
Nutzt die Shopify Cart AJAX API (/cart/change.js) sowie die Section Rendering API,
damit sich alles ohne Klick auf "Aktualisieren" live aktualisiert.
Der "Aktualisieren"-Button bleibt als Fallback bestehen, falls JS nicht laedt. */
(function () {
if (window.MGCartLoaded) return;
window.MGCartLoaded = true;
function bind() {
var wrapper = document.getElementById('mg-cart-wrapper');
var content = document.getElementById('mg-cart-content');
if (!wrapper || !content) return;
var sectionId = wrapper.getAttribute('data-section-id');
if (!sectionId) return;
var inputs = content.querySelectorAll('input[data-quantity-input]');
Array.prototype.forEach.call(inputs, function (input) {
input.addEventListener('change', handleChange);
});
function handleChange(e) {
var input = e.target;
var line = input.getAttribute('data-line');
var quantity = parseInt(input.value, 10);
if (!line || isNaN(quantity) || quantity < 0) return;
input.setAttribute('disabled', 'disabled');
fetch('/cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
})
.then(function (r) { return r.json(); })
.then(function () {
return fetch(window.location.pathname + '?section_id=' + sectionId);
})
.then(function (r) { return r.text(); })
.then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var newContent = doc.getElementById('mg-cart-content');
var currentContent = document.getElementById('mg-cart-content');
if (newContent && currentContent && currentContent.parentNode) {
currentContent.parentNode.replaceChild(newContent, currentContent);
}
bind();
})
.catch(function () {
input.removeAttribute('disabled');
});
}
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', bind);
} else {
bind();
}
})();
